import axios from 'axios';
import { UTILITY_PROVIDERS_URL } from '../../API/Api';

//GET ALL UTILITY
const getAllUtility = async (token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'GET',
		baseURL: `${UTILITY_PROVIDERS_URL}`,
		headers: headers,
	});
	return response.data;
};

const searchUtility = async (data, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'GET',
		baseURL: `${UTILITY_PROVIDERS_URL}`,
		headers,
		params: data,
	});

	return response.data;
};

//post a new utility

const postNewUtility = async (data, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'POST',
		baseURL: `${UTILITY_PROVIDERS_URL}/create`,
		headers: headers,
		data: data,
	});
	return response.data;
};

//DELETE UTILITY

const deleteUtility = async (id, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'Delete',
		baseURL: `${UTILITY_PROVIDERS_URL}/delete`,
		headers: headers,
		data: id,
	});

	return response.data.data.id;
};

//EDIT UTILITY PROVIDER

const editUtility = async (data, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'POST',
		baseURL: `${UTILITY_PROVIDERS_URL}/edit`,
		headers: headers,
		data: data,
	});

	return response.data;
};

const getSingleUtility = async (id, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'GET',
		baseURL: `${UTILITY_PROVIDERS_URL}/${id}`,
		headers: headers,
	});
	return response.data;
};

const utilityServices = {
	getAllUtility,
	postNewUtility,
	deleteUtility,
	editUtility,
	getSingleUtility,
	searchUtility,
};
export default utilityServices;
